<template>
  <v-app-bar color="accent" dense app dark>
    <v-btn icon @click.stop="emitHandler">
      <v-icon v-show="!mini" class="white--text">mdi-menu-open</v-icon>
      <v-icon v-show="mini" class="white--text">mdi-menu</v-icon>
    </v-btn>
    <v-toolbar-title class="mr-12 align-center">
      <span>原価管理システム</span>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-menu :nudge-width="100" offset-y fixed z-index="9999">
      <template v-slot:activator="{ on }">
        <v-btn color="secondary" small v-on="on">
          <v-icon>mdi-account-circle</v-icon>
          <span class="mx-2">{{ user.user_name }}</span>
        </v-btn>
      </template>
      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <v-avatar color="accent">
                <span class="white--text headline">{{ user.icon_name }}</span>
              </v-avatar>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title disabled>{{ user.company_name }}</v-list-item-title>
              <!-- <v-list-item-subtitle v-if="user.role_id == 0" disabled>権限：{{ user.permission_name }}</v-list-item-subtitle> -->
              <v-list-item-subtitle disabled>権限：{{ user.role_name }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list flat>
          <v-list-item-group>
            <v-list-item v-if="clientPermission" @click.prevent="comform('/client')">
              <v-list-item-icon>
                <v-icon color="accent">mdi-tools</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>企業情報</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="profilePermission" @click.prevent="comform('/profile')">
              <v-list-item-icon>
                <v-icon color="accent">mdi-cogs</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>プロフィール</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="logout">
              <v-list-item-icon>
                <v-icon color="accent">mdi-account-arrow-right</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>ログアウト</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import { UserStateActions } from "@/store/module/user-state";
  import AuthApi from "@/api/auth-api";

  export default {
    name: "GlobalHeader",
    props: ["user", "drawer", "mini"],
    data: () => ({
      clientPermission: true,
      profilePermission: true
    }),
    created() {
      this.initialize();
    },
    methods: {
      initialize() {
        if (this.user.role_id == 0) {
          this.clientPermission = this.user.permission_config.CTSG00001.read && this.user.permission_config.CTSG00001.update;
          this.profilePermission = this.user.permission_config.CTSG00002.read && this.user.permission_config.CTSG00002.update;
        } else if (this.user.role_id == 2) {
          this.clientPermission = false;
          this.profilePermission = false;
        }
        else {
          this.profilePermission = false;
        }
        this.authApi = new AuthApi();
      },
      emitHandler () {
        this.$emit("updated");
      },
      comform (value) {
        this.$emit('comform', value);
      },
      logout() {
        const promise = this.authApi.logout();
        promise.then((response) => {
          this.$emit('success', response.data.message);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if(error.response){
            this.$emit("error",error.response.data.message);
          }else{
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          useAppInsights().clearAuthenticatedUserContext()
          this.$store.dispatch(UserStateActions.deleteAuth);
          this.$store.dispatch(UserStateActions.deleteUser);
          this.$router.push({ name: "Login" });
        });
      }
    }
  };
</script>